import { render, staticRenderFns } from "./summernoteFrame.vue?vue&type=template&id=4497b629&scoped=true&"
import script from "./summernoteFrame.vue?vue&type=script&lang=js&"
export * from "./summernoteFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497b629",
  null
  
)

export default component.exports